import AppConfig from "../../AppConfig.js";
import {BOOKING_TYPE_SAUNA, ENTRY_DURATION_DAY, ENTRY_TYPE_NORMAL} from "../../AppConstants.js";
import * as booking_select_export from "./booking.scenarios.select.export.svelte.js";

let date = new Date();
let year = date.getFullYear();
let month = ("0" + (date.getMonth() + 1)).slice(-2); // Months are zero based
let day = ("0" + date.getDate()).slice(-2);
//const sToday = `${year}-${month}-${day}`;
const sToday = `${day}-${month}-${year}`;

export const booking = $state({
  sPreselectedBookingType: false, // "se" "sa" "ae" - komt via de dropdown op de homepage
  sBookingType: BOOKING_TYPE_SAUNA,
  iBookingUpdateCounterForUIElements: 0, // heel handig om complexe $effect calls niet in een loop te laten komen
  oBookingSummary: {
    aPeople: [],
    //bShowReceipt: false,
    bDoAllPeopleHaveSameBooking: true,
    iNrOfPeople: 0,
    iLastUpdateTime: Date.now()
    //oProductPeopleCount: {}
  },

  // aDaysThatCannotBeBooked: [], // dit was de oude GuestLimit
  bWasBookingTypeAtStartPackageDeal: false,
  iUseThisEntryIDForFirstPerson: false,
  iPreselectedTreatmentSubcat: false,
  sPreselectedTreatmentSubcatTitle: false,
  iPreselectedPackageDealID: false,
  iPreselectedTreatmentID: false,
  iPreselectionTitle: false,
  iPreselectionImgUrl: false,
  iPreselectionContent: false,
  sPreselectedDate: false,
  sPreselectedDateDay: false,
  sPreselectedDateMonth: false,
  sPreselectedDateYear: false,
  sSelectedEntryType: ENTRY_TYPE_NORMAL, // dit is geen PREset maar binnen de reserveerstraat gekozen speciaal soort entree.. gaat ook niet over dag of avond maar bijv Badenkaart Entree
  bStep14SelectionMade: false, // flag om te tracken of Step14 selectie is gemaakt (voorkomt te vroeg toevoegen van entreeproducten)
  sStep10CategoryChoice: false, // 'entree' | 'arrangement' | 'badenkaart' - keuze gemaakt in Step10

  bIsAction: false,
  iPreselectedActionEntryProductID: false,
  aPresetUpsellProductIDs: [], // is voor die opties die bijvoorbeeld met een grouponactie worden meegegeven
  aExtraBoekbareEntreesNaastActie: [],
  aValidRedeemCodes: [],
  aDaysActionIsAvailableFor: [],

  sValidGiftCardCode: false, // NB lijkt niet meer gebruikt te worden
  lValidGiftcardCodes: [],
  iValidGiftcardValue: null, // alle toegepaste giftcards bij elkaar

  iGiftCardValueCents: false,
  sGiftCardError: false,

  sValidBadenkaartCode: false,
  lValidBadenkaartCodes: [],
  lRemovedBadenkaartCodes: [],
  sBadenkaartError: false,

  // iInitialNrOfPeople staat default bewust op 0 en niet op 1 omdat al die dan een waarde anders dan 0 heeft dan is ook later duidelijk dat we met een preset begonnen zijn
  iInitialNrOfPeople: 0,      // als het niet fixed dan beginnen we met dit aantal als die groter is dan 0 (hij is al aangepast aan booking.iMinimumAmountOfPeople of fixed)
  iFixedNrOfPeople: false,    // deze is makkelijk.. dat getal gebruiken we en stap 11 slaan we in beide richtingen over
  iMinimumAmountOfPeople: 1,  // hier hoeven we in de boot niet rekening mee te houden, dat doet iInitialNrOfPeople al die is aangepast aan dit minimum, maar we moeten er wel voor zorgen dat je geen kleiner aantal kan kiezen

  sArrivalDate: false,
  iArrivalDay: false,
  sArrivalDay: false,
  iArrivalMonth: false,
  sArrivalMonth: false,
  iArrivalYear: false,
  sArrivalYear: false,
  iArrivalTime: false,
  sArrivalTime: false,
  iArrivalHour: false,
  iFirstPossibleArrivalTime: AppConfig.getIDefaultOpeningTime(),
  iLastPossibleArrivalTime: AppConfig.getIDefaultLastEntryTime(),
  iDepartureTime: false,
  sDepartureTime: false,
  iDepartureHour: false,
  iFirstPossibleDepartureTime: AppConfig.getIDefaultOpeningTime(),
  iLastPossibleDepartureTime: AppConfig.getIDefaultLastEntryTime(),
  sPreferredPartOfTheDay: ENTRY_DURATION_DAY, // lastige is dat je dit ook kan instellen voordat je daarna bijvoorbeeld een arrangement kiest.. dus deze instelling moet ook los van eventuele entreetype keuze bewaard worden

  bWantsDinner: false,
  sPreferredDinnerTime: '',
  sPreferredDinnerTimeLabel: '',

  //bWantsSauna: true, // belangrijk dat dit default true is om actieboekingen goed te laten gaan <- 2025 niet meer actueel, alles is sauna
  bShowListOfPackageDeals: false, // de default is dat we een entree komen boeken zonder een arrangement aan te bieden

  iCurrentSelectedPackagedealID: 0,
  lPeople: [],

  mTotals: { // steeds bij een mutatie on the fly berekenen.. in memory berekenen we de prijs per persoon wel, maar in state slaan we alleen het eindresultaat op.. in deze website is er namelijk geen weergave per persoon.. als die er ooit wel is kan het subtotaal per persoon ook in de store opgeslagen worden
    bWereTotalsErrorFree: null,
    mSubTotalYourStay: {
      iCents: 0,
      mFriendly: {
        sEuros: '0',
        sCents: '00'
      }
    },
    mSubTotalPackageDeal: {
      iCents: 0,
      mFriendly: {
        sEuros: '0',
        iCents: '00'
      }
    },
    mSubTotalTreatments: {
      iCents: 0,
      mFriendly: {
        sEuros: '0',
        iCents: '00'
      }
    },
    mSubTotalForm: {
      iCents: 0,
      mFriendly: {
        sEuros: '0',
        iCents: '00'
      }
    },
    mTotal: {
      iCents: 0,
      mFriendly: {
        sEuros: '0',
        iCents: '00'
      }
    }
  }
});

window.hmk_booking = () => {
  console.log($state.snapshot(booking));
}

window.hmk_booking_summary = () => {
  console.log($state.snapshot(booking.oBookingSummary));
}

window.hmk_booking_export = () => {
  console.log(booking_select_export.getBookingExport(true));
}
